import { createRoot } from "react-dom/client";
import Codex from "nodes/codex/Codex";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// import reportWebVitals from './reportWebVitals';

const container = document.getElementById("mizony") as HTMLElement;

createRoot(container).render(<Codex />);

/**
 * Analytics set-up
 * Projects concept-libramium-com
 *
 * Notes:
 * - Firebase JS SDK v7.20.0 and later
 * - measurementId is optional
 * - https://console.firebase.google.com/u/0/project/concept-libramium-com/analytics/app/web:ODkyZGFiYjAtMTBkZS00ZmNjLTk3YzctZWM1ZWIwZjI0ZWVl/overview
 */
process.env.NODE_ENV === "production" &&
  getAnalytics(
    initializeApp({
      apiKey: "AIzaSyCSg8hhO_ZoGP8lV9PkKJJ3foSRVMJRyDw",
      authDomain: "concept-libramium-com.firebaseapp.com",
      projectId: "concept-libramium-com",
      storageBucket: "concept-libramium-com.firebasestorage.app",
      messagingSenderId: "408052928113",
      appId: "1:408052928113:web:4787ef4bd39bdda19d15d0",
      measurementId: "G-JYM0HJPTCT",
    })
  );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
